export const G_VERSION = '4.0.0'
export const G_SESSIONNAME = 'themecore_theme'
